(function ($) {

    /**
     * UTILITIES
     */

    var helpers = {
        getViewportWidth: function(){
            let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            return viewportWidth;
        },
        isMobile: function(){
            let viewportWidth = helpers.getViewportWidth();
            let isMobile = viewportWidth <= mobileBreakpoint ? true : false;
            return isMobile;
        }
    }

    /**
     * SETUP
     */
    const mobileBreakpoint = 768;
    let viewportWidth = helpers.getViewportWidth();
    let isMobile = helpers.isMobile();

    window.addEventListener('resize', () => {
        // We execute the same script as before
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    let dashboardHandler = {
        init: function(){
           this.newsSlider();
           this.servicesSlider();
        },

        newsSlider: function(){

            window.addEventListener('resize', () => {
                $('.news--list').slick('resize');
            });

            $('.news--list').slick({
                mobileFirst: true,
                arrows: false,
                dots: true,
                infinite: false,
                speed: 300,
                slidesToShow: 1,
                variableWidth: true,
                responsive: [
                    {
                      breakpoint: 320,
                      settings: {
                        slidesToShow: 1,
                      }
                    },
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 2,
                      }
                    },
                    {
                        breakpoint: mobileBreakpoint,
                        settings: 'unslick'
                    }
                ]
            });

        },

        servicesSlider: function(){

            // window.addEventListener('resize', () => {
            //     $('.slider-services').slick('resize');
            // });

            $('.slider-services').slick({
                // mobileFirst: true,
                arrows: true,
                appendArrows: '.slick-nav',
                dots: true,
                appendDots: '.slick-nav',
                infinite: false,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1
            });

        }
    }
    if( $('body.dashboard').length > 0 )
        dashboardHandler.init();


    if($('#select-filter-categories').length > 0){
      let select = $('#select-filter-categories');
      select.on('change', function(){
        window.location = select.val();
      })
    }

    // disable addres field checkout
    $('form.crm-fields-disabled .form-row.address-field').each(function(){
      let itemForm = $(this);
      itemForm.find('input, select').attr('disabled', '');
      let itemInput = jQuery(itemForm.find('input, select')[0]);
      let nameInput = itemInput.attr('name');
      itemInput.removeAttr('name');
      itemForm.append('<input type="hidden" name="' + nameInput + '" value="' + itemInput.val() + '"/>');
    })


})(jQuery);
